import api from './api';
import StockAccessService from './stock-access.service';

class SettingStoreService {
  getDataBranches(dataForm) {
    return api.post('/merchant/branches', dataForm);
  }

  duplicateBranch(branchId) {
    return api.post('/merchant/branch/duplicate/' + branchId);
  }

  createNewBranch() {
    return api.post('/merchant/branch');
  }

  getDataBranchDetail(branchId) {
    if(branchId) {
      return api.post('/merchant/branch/' + branchId);
    } else {
      return api.post('/merchant/branch');
    }
  }

  addOrUpdateBranch(dataForm) {
    return api.post('/merchant/branch-create-or-update', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  // SF283: Advocado outlets for the sales channel's outlet picker.
  getAdvocadoOutlets() {
    return api.post('/merchant/advocado/outlets');
  }

  // SF263: items this sale channel may pin to the popup shown after the QR is scanned.
  getPromoPopupItems(dataForm) {
    return api.post('/merchant/branches/promo-popup-items', dataForm);
  }

  // SF295: upsell items this sale channel may place on its menu-page banner grid.
  getMenuBannerItems(dataForm) {
    return api.post('/merchant/branches/menu-banner-items', dataForm);
  }

  // M986: Lalamove driver booking for this sale channel's MOO Delivery orders.
  getLalamoveSetting(branchId) {
    return api.post('/merchant/branches/lalamove-setting', { branch_id: branchId });
  }

  saveLalamoveSetting(dataForm) {
    return api.post('/merchant/branches/save-lalamove-setting', dataForm);
  }

  // M986 follow-up: MOO Delivery slots and delivery charge by distance (iMakan style).
  getDeliverySlots(branchId) {
    return api.post('/merchant/branches/delivery-slots', { branch_id: branchId });
  }

  // Special Scheduled Price: the switch and the list replace what is stored.
  savePriceSchedules(branchId, priceSchedules, enabled) {
    return api.post('/merchant/branches/save-price-schedules', {
      branch_id: branchId,
      price_schedules_enabled: enabled,
      price_schedules: priceSchedules,
    });
  }

  saveDeliverySlots(dataForm) {
    return api.post('/merchant/branches/save-delivery-slots', dataForm);
  }

  getDeliveryChargeTiers(branchId) {
    return api.post('/merchant/branches/delivery-charge-tiers', { branch_id: branchId });
  }

  saveDeliveryChargeTiers(dataForm) {
    return api.post('/merchant/branches/save-delivery-charge-tiers', dataForm);
  }

  changeStatus(branchId) {
    return api.post('/merchant/branch/change-status/' + branchId);
  }

  getOrderByBranch(dataForm) {
    return api.post('/merchant/order/get-list-by-branch', dataForm, StockAccessService.requestConfig(dataForm));
  }

  getOrderByPhysicBranch(dataForm) {
    return api.post('/merchant/order/get-list-by-physical-branch', dataForm, StockAccessService.requestConfig(dataForm));
  }

  getOrderKDSByPhysicBranch(dataForm) {
    return api.post('/merchant/order/get-kds-list-by-physical-branch', dataForm, StockAccessService.requestConfig(dataForm));
  }

  // Short-lived socket token for the board this caller can already read. Behind
  // the same stock passcode as the board's own details, so a screen that cannot
  // read the board cannot watch it either.
  //
  // Returns { enabled: false } when realtime is switched off server-side, which
  // is a normal answer: the board keeps polling.
  getWsTokenForBoard(dataForm) {
    return api.post('/merchant/order/ws-token/board', dataForm, StockAccessService.requestConfig(dataForm));
  }

  orderDetail(dataForm) {
    return api.post('/merchant/order/detail', dataForm, StockAccessService.requestConfig(dataForm));
  }

  moveOrder(dataForm) {
    return api.post('/merchant/order/move', dataForm, StockAccessService.requestConfig(dataForm));
  }

  moveOrderKDS(dataForm) {
    return api.post('/merchant/order/move-kds', dataForm, StockAccessService.requestConfig(dataForm));
  }

  // M985: tap on a chit row's QTY — strike / un-strike it on this station.
  strikeKdsItem(dataForm) {
    return api.post('/merchant/order/strike-kds-item', dataForm, StockAccessService.requestConfig(dataForm));
  }

  collectOrderKDS(dataForm) {
    return api.post('/merchant/order/collect-kds', dataForm, StockAccessService.requestConfig(dataForm));
  }

  changeWaitingTime(dataForm) {
    return api.post('/merchant/branch-change-waiting-time', dataForm);
  }

  stopOrdering(dataForm) {
    return api.post('/merchant/branch-stop-ordering', dataForm);
  }

  checkPasscodeOrderPage(dataForm) {
    return api.post('/merchant/order/check-passcode', dataForm);
  }

  checkStockPasscodeExists(dataForm) {
    return api.post('/merchant/check-stock-passcode-exists', dataForm);
  }

  retryOrder(dataForm) {
    return api.post('/merchant/order/retry', dataForm, StockAccessService.requestConfig(dataForm));
  }

  // M986: book the Lalamove driver again for a delivery that ended undelivered.
  lalamoveBookAgain(dataForm) {
    return api.post('/merchant/order/lalamove-book-again', dataForm, StockAccessService.requestConfig(dataForm));
  }

  // M986: manual-flow stores (update_order_status_without_pos) accept a paid
  // order — delivery_method 1 Lalamove Motorcycle | 2 Lalamove Car | 3 Own delivery.
  acceptOrder(dataForm) {
    return api.post('/merchant/order/accept', dataForm, StockAccessService.requestConfig(dataForm));
  }

  // M1005: Lalamove price of a pending delivery order by Motorcycle (1) / Car (2).
  getLalamoveQuote(dataForm) {
    return api.post('/merchant/order/lalamove-quote', dataForm, StockAccessService.requestConfig(dataForm));
  }

  // M986: reject a pending order; the API starts the refund.
  rejectOrder(dataForm) {
    return api.post('/merchant/order/reject', dataForm, StockAccessService.requestConfig(dataForm));
  }

  saveKdsSettings(dataForm) {
    return api.post('/merchant/kds/save-settings', dataForm, StockAccessService.requestConfig(dataForm));
  }

  // M896. Plural on purpose - merchant/branch/{id?} is registered first and would swallow these.
  importBranchesJsonPreview(dataForm) {
    return api.post('/merchant/branches/import-json/preview', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  importBranchesJson(dataForm) {
    return api.post('/merchant/branches/import-json', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}

export default new SettingStoreService();
